import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { AuthService } from '../../../services/auth/auth-service';
import { Service } from '../../../models/service';
import { Router, NavigationEnd } from '@angular/router';
import { TranslateService } from '../../../services/translate.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-page-name',
  templateUrl: './page-name.component.html'
})
export class PageNameComponent implements OnInit, OnDestroy, OnChanges {
  @Input() service: Service | null = null;
  pageNameClass: string = '';
  pageName: string = '';
  showPageNameBar: boolean = true;
  private routerSubscription?: Subscription;

  constructor(
    public authService: AuthService,
    public translateService: TranslateService,
    private readonly router: Router
  ) {}

  ngOnInit() {
    this.updatePageInfo();

    // Listen to route changes to update page info
    this.routerSubscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.updatePageInfo();
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['service']) {
      this.updatePageInfo();
    }
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  private updatePageInfo() {
    const currentRoute = this.router.url;
    this.showPageNameBar = true;
    if (currentRoute.startsWith('/admin/users')) {
      this.pageNameClass = '';
      this.pageName = $localize`:@@user_management_title:User Management`;
    } else if (currentRoute.startsWith('/user/change-password')) {
      this.pageNameClass = '';
      this.pageName = $localize`:@@change-password-title:Change Password`;
    } else if (this.service && this.service.name !== 'My Account Page') {
      this.pageNameClass = 'service-page';
      this.pageName = this.translateService.localizeId(this.service.name);
    } else if (currentRoute === '/' || currentRoute === '') {
      if (this.authService.currentUser$) {
        this.pageNameClass = 'my-account-page';
        this.pageName = $localize`:@@My account:My account`;
      } else {
        this.pageNameClass = 'demonstration-mode';
        this.pageName = $localize`:@@Demonstration mode:Demonstration mode`;
      }
    } else if (currentRoute.startsWith('/part-b')) {
      this.pageNameClass = '';
      this.pageName = '';
      this.showPageNameBar = false;
    } else if (
      currentRoute.startsWith('/inspector') &&
      !currentRoute.match(/\/inspector\/[^/]+\/[^/]+\/[^/]+/)
    ) {
      // Inspector list view (not detail view)
      this.pageNameClass = '';
      this.pageName = $localize`:@@files-view:Files view`;
      this.showPageNameBar = true;
    } else {
      this.pageNameClass = '';
      this.pageName = '';
    }
  }
}
